module.exports = __webpack_public_path__ + "img/wd.cc859d37.png";